// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UseTakeoffsLayoutStateQueryVariables = Types.Exact<{
  planPackageId: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type UseTakeoffsLayoutStateQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, code: string, name: string, displayName: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }>, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, itemLocations: Array<{ __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType }, parents: Array<{ __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType } }> }> } };

export type UseTakeoffsLayoutState_OptionFragment = { __typename?: 'ReadyPlanOption', id: string, code: string, name: string, displayName: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined };

export type UseTakeoffsLayoutState_LocationFragment = { __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType }, parents: Array<{ __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType } }> };

export const UseTakeoffsLayoutState_OptionFragmentDoc = gql`
    fragment UseTakeoffsLayoutState_Option on ReadyPlanOption {
  id
  code
  name
  displayName
  type {
    id
    isElevation
  }
  location {
    id
    name
  }
}
    `;
export const UseTakeoffsLayoutState_LocationFragmentDoc = gql`
    fragment UseTakeoffsLayoutState_Location on Location {
  ...Named
  type {
    code
  }
  parents {
    ...Named
    type {
      code
    }
  }
}
    ${NamedFragmentDoc}`;
export const UseTakeoffsLayoutStateDocument = gql`
    query UseTakeoffsLayoutState($planPackageId: ID!, $versionId: ID!) {
  planPackage(id: $planPackageId, versionId: $versionId) {
    id
    options {
      ...UseTakeoffsLayoutState_Option
    }
    costCodes {
      ...Named
    }
    itemLocations {
      ...UseTakeoffsLayoutState_Location
    }
  }
}
    ${UseTakeoffsLayoutState_OptionFragmentDoc}
${NamedFragmentDoc}
${UseTakeoffsLayoutState_LocationFragmentDoc}`;

/**
 * __useUseTakeoffsLayoutStateQuery__
 *
 * To run a query within a React component, call `useUseTakeoffsLayoutStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseTakeoffsLayoutStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseTakeoffsLayoutStateQuery({
 *   variables: {
 *      planPackageId: // value for 'planPackageId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useUseTakeoffsLayoutStateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UseTakeoffsLayoutStateQuery, UseTakeoffsLayoutStateQueryVariables> & ({ variables: UseTakeoffsLayoutStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UseTakeoffsLayoutStateQuery, UseTakeoffsLayoutStateQueryVariables>(UseTakeoffsLayoutStateDocument, options);
      }
export function useUseTakeoffsLayoutStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UseTakeoffsLayoutStateQuery, UseTakeoffsLayoutStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UseTakeoffsLayoutStateQuery, UseTakeoffsLayoutStateQueryVariables>(UseTakeoffsLayoutStateDocument, options);
        }
// @ts-ignore
export function useUseTakeoffsLayoutStateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UseTakeoffsLayoutStateQuery, UseTakeoffsLayoutStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UseTakeoffsLayoutStateQuery, UseTakeoffsLayoutStateQueryVariables>;
export function useUseTakeoffsLayoutStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UseTakeoffsLayoutStateQuery, UseTakeoffsLayoutStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UseTakeoffsLayoutStateQuery | undefined, UseTakeoffsLayoutStateQueryVariables>;
export function useUseTakeoffsLayoutStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UseTakeoffsLayoutStateQuery, UseTakeoffsLayoutStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UseTakeoffsLayoutStateQuery, UseTakeoffsLayoutStateQueryVariables>(UseTakeoffsLayoutStateDocument, options);
        }
export type UseTakeoffsLayoutStateQueryHookResult = ReturnType<typeof useUseTakeoffsLayoutStateQuery>;
export type UseTakeoffsLayoutStateLazyQueryHookResult = ReturnType<typeof useUseTakeoffsLayoutStateLazyQuery>;
export type UseTakeoffsLayoutStateSuspenseQueryHookResult = ReturnType<typeof useUseTakeoffsLayoutStateSuspenseQuery>;
export type UseTakeoffsLayoutStateQueryResult = ApolloReactCommon.QueryResult<UseTakeoffsLayoutStateQuery, UseTakeoffsLayoutStateQueryVariables>;